import React, { useMemo } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

const StatsCard = ({ loginAdsList = [] }) => {
    const stats = useMemo(() => {
        const totalImpressions = loginAdsList.reduce(
            (sum, ad) => sum + (Number(ad.impressions) || 0), 0
        );

        const totalClicks = loginAdsList.reduce(
            (sum, ad) => sum + (Number(ad.clicks) || 0), 0
        );

        return [
            { title: "Total Ads", value: loginAdsList.length, icon: "bx-credit-card", color: "primary" },
            { title: "Active Ads", value: loginAdsList.filter(g => g.status === "Active").length, icon: "bx-check-circle", color: "success" },
            { title: "Inactive Ads", value: loginAdsList.filter(g => g.status === "Inactive").length, icon: "bx-x-circle", color: "danger" },
            { title: "Total Impressions", value: totalImpressions, icon: "bx-show", color: "info" },
            { title: "Total Clicks", value: totalClicks, icon: "bx-mouse", color: "warning" }
        ];
    }, [loginAdsList]);

    return (
        <Row className="mb-4 gap-2">
            {stats.map((stat, index) => (
                <Col key={index} xl md="6">
                    <Card className="border-0 shadow-sm mb-0">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div
                                    className={`avatar-sm bg-${stat.color}-subtle text-${stat.color} rounded-3 p-2 me-3 d-flex align-items-center justify-content-center`}
                                >
                                    <i className={`bx ${stat.icon} fs-3`}></i>
                                </div>

                                <div>
                                    <h6 className="text-muted mb-1">{stat.title}</h6>
                                    <h4 className="mb-0 fw-bold">{stat.value}</h4>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default StatsCard;